module.exports = __webpack_public_path__ + "2e2a552befc9759ebf515f089ef4430b.svg";